module.exports = __webpack_public_path__ + "static/media/meta.39c5e6a1.jpg";